import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Shared header for inner pages: office-hero background, breadcrumb, big title,
// then a numbered section label + subheading.
export default function PageHeader({
    breadcrumb,
    title,
    number,
    label,
    heading,
    children,
    testid,
}) {
    return (
        <section data-testid={testid} className="relative">
            {/* Hero image band */}
            <div className="relative h-[46vh] min-h-[340px] w-full overflow-hidden">
                <img
                    src="/images/office-hero.jpg"
                    alt=""
                    className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#1a120c]/70 via-[#1a120c]/60 to-[#1a120c]" />
                <div className="absolute inset-0 flex items-end">
                    <div className="mx-auto w-full max-w-6xl px-6 pb-10">
                        <nav className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-amber-300/80">
                            <Link
                                to="/"
                                className="transition-colors hover:text-amber-200"
                            >
                                The Waiting Room
                            </Link>
                            <span className="text-amber-500/40">/</span>
                            <span className="text-amber-100/60">
                                {breadcrumb}
                            </span>
                        </nav>
                        <motion.h1
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            className="mt-4 font-serif text-4xl leading-tight tracking-tight text-amber-50 sm:text-5xl lg:text-6xl"
                        >
                            {title}
                        </motion.h1>
                    </div>
                </div>
            </div>

            {/* Numbered label + heading */}
            <div className="relative mx-auto w-full max-w-6xl px-6 pt-16">
                <span
                    aria-hidden="true"
                    className="pointer-events-none absolute right-4 top-4 select-none font-serif text-[7rem] leading-none text-amber-500/[0.07] sm:text-[10rem]"
                >
                    {number}
                </span>
                <div className="flex items-baseline gap-4">
                    <span className="font-serif text-sm tracking-[0.3em] text-amber-500">
                        {number}
                    </span>
                    <span className="h-px flex-1 bg-amber-500/20" aria-hidden="true" />
                    <span className="text-xs uppercase tracking-[0.3em] text-amber-200/50">
                        {label}
                    </span>
                </div>
                <h2 className="mt-6 max-w-3xl font-serif text-2xl tracking-tight text-amber-50 sm:text-3xl lg:text-4xl">
                    {heading}
                </h2>
                {children}
            </div>
        </section>
    );
}
